/* eslint-disable @typescript-eslint/naming-convention */
export enum TicketStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED',
  UNDER_EVALUATION = 'UNDER_EVALUATION'
}
/* eslint-enable @typescript-eslint/naming-convention */
